import { createNode } from '@glueapp/graph-types';

export const Comparison = createNode({
    id: 'Comparison',
    name: 'Comparison',
    description: 'Gives true or false for all possible comparison relationships between two numbers',
    aiDescription:
        'Compares two numbers across all six relationships at once. Connect numbers to "First" and "Second" input ports; outputs boolean ports "First < Second", "First <= Second", "First = Second", "First != Second", "First >= Second", and "First > Second".',
    category: 'Comparison',
    color: '#46aa43',
    integration: undefined,
    inPorts: {
        First: {
            kind: 'number',
        },
        Second: {
            kind: 'number',
        },
    },
    outPorts: {
        'First < Second': { kind: 'boolean' },
        'First <= Second': { kind: 'boolean' },
        'First = Second': { kind: 'boolean' },
        'First != Second': { kind: 'boolean' },
        'First >= Second': { kind: 'boolean' },
        'First > Second': { kind: 'boolean' },
    },
    execute: function (input) {
        const first = input.inPorts.First;
        const second = input.inPorts.Second;

        return {
            output: {
                'First < Second': first < second,
                'First <= Second': first <= second,
                'First = Second': first === second,
                'First != Second': first !== second,
                'First >= Second': first >= second,
                'First > Second': first > second,
            },
        };
    },
});
